declare module "@mui/material/styles/createPalette" {
	interface PaletteOptions {
		storebookGreen?: PaletteColorOptions;
		storebookDarkGreen?: PaletteColorOptions;
		storebookBlue?: PaletteColorOptions;
		storebookDarkBlue?: PaletteColorOptions;
	}
}

export const customColors = {
	storebookGreen: "#36B2AA",
	storebookDarkGreen: "#3d8687",
	storebookBlue: "#07568A",
	storebookDarkBlue: "#003048",
	storebookRed: "#8E3B46",
	storebookDarkRed: "#6B0F1A"
};
